export {default} from './ForgotPassword';



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword/index.ts